import type { Location } from '../App.types'

export default function formatLocation(location: Location) {
  const { street, detail: doorNumber, zip, city } = location

  const streetAndNumber = doorNumber ? `${street} ${doorNumber}` : street
  const zipAndCity = zip && city ? `, ${zip} ${city}` : city ? `, ${city}` : zip ? `, ${zip}` : ''

  return streetAndNumber.concat(zipAndCity)
}
